import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { 
    GetAllGeofences,
    GetGeofenceByID,
    CreateGeofence,
    UpdateGeofence,
    DeleteGeofence,
    ValidateLocation,
    GetGeofenceLogs,
    LogGeofenceEvent
} from "helpers/api_method";

// Get all geofences
export const getAllGeofences = createAsyncThunk(
    "geofence/getAllGeofences", 
    async (_, { rejectWithValue }) => {
        try {
            const response = await GetAllGeofences();
            return response as any;
        } catch (error: any) {
            if (error === 'Request timeout. Please try again.' || error.message?.includes('timeout')) {
                return rejectWithValue({ error: 'Request timeout. Please try again.' });
            }
            return rejectWithValue({ error: error.message || 'Failed to fetch geofences' });
        }
    }
);

// Get geofence by ID
export const getGeofenceByID = createAsyncThunk(
    "geofence/getGeofenceByID",
    async (geofence_id: string, { rejectWithValue }) => {
        try {
            const response = await GetGeofenceByID(geofence_id);
            return response as any;
        } catch (error: any) {
            if (error === 'Request timeout. Please try again.' || error.message?.includes('timeout')) {
                return rejectWithValue({ error: 'Request timeout. Please try again.' });
            }
            return rejectWithValue({ error: error.message || 'Failed to fetch geofence details' });
        }
    }
);

// Create geofence
export const createGeofence = createAsyncThunk(
    "geofence/createGeofence",
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await CreateGeofence(data);
            const apiResponse = response as any;
            if (apiResponse.status) {
                toast.success("Geofence created successfully", { autoClose: 2000 });
            } else {
                toast.error(apiResponse.message || "Failed to create geofence", { autoClose: 2000 });
            }
            return apiResponse;
        } catch (error: any) {
            toast.error("Failed to create geofence", { autoClose: 2000 });
            return rejectWithValue({ error: error.message || 'Failed to create geofence' });
        }
    }
);

// Update geofence
export const updateGeofence = createAsyncThunk(
    "geofence/updateGeofence",
    async ({ geofence_id, data }: { geofence_id: string; data: any }, { rejectWithValue }) => {
        try {
            const response = await UpdateGeofence(geofence_id, data);
            const apiResponse = response as any;
            if (apiResponse.status) {
                toast.success("Geofence updated successfully", { autoClose: 2000 });
            } else {
                toast.error(apiResponse.message || "Failed to update geofence", { autoClose: 2000 });
            }
            return apiResponse;
        } catch (error: any) {
            toast.error("Failed to update geofence", { autoClose: 2000 });
            return rejectWithValue({ error: error.message || 'Failed to update geofence' });
        }
    }
);

// Delete geofence
export const deleteGeofence = createAsyncThunk(
    "geofence/deleteGeofence",
    async (geofence_id: string, { rejectWithValue }) => {
        try {
            const response = await DeleteGeofence(geofence_id);
            const apiResponse = response as any;
            if (apiResponse.status) {
                toast.success("Geofence deleted successfully", { autoClose: 2000 });
            }
            return apiResponse;
        } catch (error: any) {
            toast.error("Failed to delete geofence", { autoClose: 2000 });
            return rejectWithValue({ error: error.message || 'Failed to delete geofence' });
        }
    }
);

// Validate location
export const validateLocation = createAsyncThunk(
    "geofence/validateLocation",
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await ValidateLocation(data);
            return response as any;
        } catch (error: any) {
            return rejectWithValue({ error: error.message || 'Failed to validate location' });
        }
    }
);

// Get geofence logs
export const getGeofenceLogs = createAsyncThunk(
    "geofence/getGeofenceLogs",
    async (params: any = {}, { rejectWithValue }) => {
        try {
            const response = await GetGeofenceLogs(params);
            return response as any;
        } catch (error: any) {
            return rejectWithValue({ error: error.message || 'Failed to fetch geofence logs' });
        }
    }
);

// Log geofence event
export const logGeofenceEvent = createAsyncThunk(
    "geofence/logGeofenceEvent",
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await LogGeofenceEvent(data);
            return response as any;
        } catch (error: any) {
            return rejectWithValue({ error: error.message || 'Failed to log geofence event' });
        }
    }
);
